import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
// import SettingContext from '@/product/context/setting/settingContext'

import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import DisapprovalReasonManagement from './disapprovalReason'

const DisapprovalReasonList = () => {
    const settingContext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus,
        clearResponse,
    } = settingContext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        record: {},
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            status: '',
            id: 0,
            table: 'disapproval_reason',
            updateDisapproval: true,
        },
        onSubmit: (values) => {
            searchTableAction(values, false, 'disapproval_remove')
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'CommunicationSearchTable' &&
                responseStatus.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                changeChangeStatus()
                searchTableFetch(formikView.values, 'disaaproval_reason')
            }
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'disapproval_create' &&
                responseStatus.status === 'success'
            ) {
                setTimeout(() => {
                    searchTableFetch(formikView.values, 'disaaproval_reason')
                    getGlobalVariable()
                }, 1000)
            }
        }
    }, [responseStatus])

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'disapproval_remove' &&
                responseStatus.status === 'success'
            ) {
                setTimeout(() => {
                    searchTableFetch(formikView.values, 'disaaproval_reason')
                    getGlobalVariable()
                }, 1000)
                changeChangeStatus()
            }
        }
    }, [responseStatus])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'disapproval_reason',
            orderby: 'dis.id,desc',
            filters: true,
            filters: {
                emailText: {
                    value: '',
                    type: 'in',
                    field: 'dis.email_text',
                },
                status: {
                    value: 'open',
                    type: 'in',
                    field: 'dis.status',
                },
                reason: {
                    value: '',
                    type: 'in',
                    field: 'dis.email_text',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'disaaproval_reason')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (
                search_fetch_data.from === 'disaaproval_reason' ||
                search_fetch_data.from === 'disapproval'
            ) {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'disaaproval_reason')
    }, [])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, type, id)
    }
    const onClickDelet = (id, secondaryID, type) => {
        formikSelection.setFieldValue('status', 'removed')
        formikSelection.setFieldValue('id', id)
        changeChangeStatus()
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })

        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickDelet,
            tooltipTitle: 'Delete',
        })

        return actionPush
    }
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'admin_reason_text',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Admin Reason Text',
            filterable: true,
            filterField: 'admin_reason_text',
        },

        {
            field: 'email_text',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Email Text',
            filterable: true,
            filterField: 'email_text',
        },

        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const tableActions = []

    const searchInfo = [
        {
            label: 'Email Text',
            placeholder: 'Enter email text',
            class: 'col-md-4 col-sm-6 col-12',
            type: '',
            name: 'emial_text',
            filter: true,
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Disapproval Reason
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'disapproval'}
                />
            </div>
            <DisapprovalReasonManagement
                record={search_fetch_data?.records}
                data={manage}
                function={toggleFullScreenPopup}
            />

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default DisapprovalReasonList
